import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var CompanyApi = /** @class */ (function () {
    function CompanyApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    CompanyApi.initialize = function (basePath, fetchApi) {
        if (!CompanyApi.instance) {
            CompanyApi.instance = new CompanyApi(basePath, fetchApi);
        }
        return CompanyApi.instance;
    };
    CompanyApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1CompanyApi(new Configuration(config));
    };
    return CompanyApi;
}());
export { CompanyApi };
